export default __webpack_public_path__ + "static/media/img-icon.c4ad254c.svg";